import { SHOW_NOTIFICATION, HIDE_NOTIFICATION } from "../constants";

const initialState = {
  type: "",
  content: "",
  display: false
};

export default function notifications(state = initialState, action) {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return {
        type: action.payload.type,
        content: action.payload.content,
        display: true
      };
    case HIDE_NOTIFICATION:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notifications.js